import dynamic from 'next/dynamic';
const ClinicalSetting = dynamic(() => import('./ClinicalSetting'));
export default ClinicalSetting;
